module.exports = __webpack_public_path__ + "media/images/mission-b76ad39ff098743c12d306f51f3d8554.jpg";